import { Params } from '@/shared/types/api';
import { AdminSchool } from '@/shared/types/entities/AdminSchool';
import { School } from '@/shared/types/entities/School';
import { Status } from '@/shared/types/entities/Status';
import { State } from '../index';
import { SCHOOL_MUTATION } from './mutationTypes';

export const schoolMutations = {
  [SCHOOL_MUTATION.GET_SCHOOLS]: (
    state: State,
    data: { schools: School[]; total: number },
  ) => {
    state.school.listSchools = data;
  },
  [SCHOOL_MUTATION.GET_ADMIN_SCHOOLS]: (
    state: State,
    data: { adminSchools: AdminSchool[]; total: number },
  ) => {
    state.school.adminListSchools = data;
  },
  [SCHOOL_MUTATION.GET_STATUSES]: (
    state: State,
    data: { statuses: Status[]; total: number },
  ) => {
    state.school.listStatus = data;
  },
  [SCHOOL_MUTATION.CHANGE_ENABLED]: (
    state: State,
    data: Params<'changeEnabled'>,
  ) => {
    const ids = data.organization_ids.split(',');
    const newSchools = state.school.listSchools.schools.map((school) => {
      if (ids.includes(school.id.toString())) {
        return {
          ...school,
          isEnabled: !!data.is_enabled,
        };
      }
      return school;
    });

    state.school.listSchools.schools = newSchools;
  },
};
